






























import { ValidationObserver } from 'vee-validate'
import { Component, Mixins, Prop, VModel } from 'vue-property-decorator'

import ModelSetter from '../../../../../../Mixins/ModelSetter'
import { UseFields } from '../../../../../Pi'
import { SelectOptionData } from '../../../../../Pi/types'
// import { ButtonStruct } from '../index'

@Component({
  components: {
    ValidationObserver,
  },
})
export default class TriggerCallView extends Mixins<UseFields, ModelSetter>(UseFields, ModelSetter) {
  @VModel({ type: Object }) model!: any

  @Prop({ type: Function }) readonly getTriggersFn!: () => Promise<Array<SelectOptionData>>
}
